module.exports = __webpack_public_path__ + "img/85303D81-6BD2-4BC4-AC77-48E7DA8A25BB_1_201_a-min.9cfcd470.jpeg";